import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { xmlns: "http://www.w3.org/2000/svg" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("pattern", {
        id: "a",
        width: "40",
        height: "59.428",
        patternTransform: "scale(2)",
        patternUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("rect", {
          width: "100%",
          height: "100%",
          fill: "transparent"
        }),
        _createElementVNode("path", {
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "square",
          d: "M0 70.975V47.881m20-1.692L8.535 52.808v13.239L20 72.667l11.465-6.62V52.808zm0-32.95 11.465-6.62V-6.619L20-13.24 8.535-6.619V6.619L20 13.24m8.535 4.927v13.238L40 38.024l11.465-6.62V18.166L40 11.546zM20 36.333 0 47.88m0 0v23.094m0 0 20 11.548 20-11.548V47.88m0 0L20 36.333m0 0 20 11.549M0 11.547l-11.465 6.619v13.239L0 38.025l11.465-6.62v-13.24L0 11.548v-23.094l20-11.547 20 11.547v23.094M20 36.333V13.24"
        })
      ])
    ], -1),
    _createElementVNode("rect", {
      width: "800%",
      height: "800%",
      fill: "url(#a)"
    }, null, -1)
  ])))
}
export default { render: render }